module.exports = __webpack_public_path__ + "static/media/quiz_12c.9bd12526.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/quiz_12c.jpg
// module id = 691
// module chunks = 0